import { StrictMode, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { LandingPage } from './landing/LandingPage.tsx';
import { captureInstallPrompt } from './install/install.ts';
import { isLandingPage } from './site-pages.ts';

/**
 * The entry point: the landing page, or everything else.
 *
 * **The landing page is the only page in this chunk** (OQ-48). It is the first
 * thing a newcomer sees, so it must not wait for Clerk or MapLibre, which are
 * most of the bundle: the organization's screens are a chunk of their own
 * (`app-routes.tsx`), and the landing page loads its demo map and its sign-in
 * only when they are needed. `scripts/check-landing-weight.js` fails the build
 * if either creeps back into what this file pulls in statically.
 */
// Chromium's install event can fire before the organization's chunk loads;
// held here until the map offers it (install/install.ts, OQ-58).
captureInstallPrompt();

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root is missing from index.html');
}
const root = createRoot(container);
const render = (page: ReactNode) => root.render(<StrictMode>{page}</StrictMode>);

if (isLandingPage(window.location)) {
  render(<LandingPage />);
} else {
  void import('./app-routes.tsx').then(({ pageFor }) => render(pageFor(window.location)));
}
